<template>
	<v-tabs
    bg-color=""
   style=" "
	
    center-active
     v-if="this.$route.params.id!=undefined"
   >
     <v-tab router :to='"/updatePatient/"+this.$route.params.id'>Patient</v-tab>
     <v-tab router :to='"/constantes/"+this.$route.params.id' >
       Constantes    
   </v-tab>
   <v-tab  router :to='"/observation/"+this.$route.params.id' >
       Observations    
   </v-tab>
     <v-tab router :to='"/photo/"+this.$route.params.id'>Joindre photos</v-tab>
     <v-tab router :to='"/document/"+this.$route.params.id'>Joindre Documents</v-tab>
     <!-- <v-tab router :to='"/transmissionPatient/"+this.$route.params.id'
     v-if="isAdmin()"
   >Envoyer document</v-tab> -->
     </v-tabs>
</template>

<script >
export default {
  props: [
        "show"
      
],
methods:{
isAdmin(){
  return JSON.parse(localStorage.getItem('user'))?.profil == 'admin';
}
}}

</script>
